import type { UserProfile } from '../../../auth';

type VerifierProfile = Pick<
  UserProfile,
  'firstName' | 'lastName' | 'email' | 'username'
>;

/**
 * Name recorded as the case's verifiedByName. The profile is derived from the
 * ID token (given_name / family_name) — the access token carries no profile
 * claims, so the API can't resolve this itself.
 */
export function getVerifierName(profile: VerifierProfile | null): string {
  if (!profile) return '';
  const fullName = `${profile.firstName} ${profile.lastName}`.trim();
  return fullName || profile.email || profile.username;
}
